import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useSEO } from "@/hooks/useSEO";
import { Skeleton } from "@/components/ui/skeleton";

export const fmtDate = (d) => new Date(d).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

export default function Blog() {
  useSEO({ title: "Blog — Game Deals, Guides & Key Tips", description: "Fresh guides on cheap game keys, Steam and Rockstar activation, the best games to grab right now and paying with USDT.", path: "/blog" });
  const [posts, setPosts] = useState(null);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)); }, []);
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-8 pt-10 space-y-10">
      <div className="rise">
        <p className="label-eyebrow text-emerald-400">GameRealm Blog</p>
        <h1 className="font-display font-bold tracking-tighter text-4xl sm:text-5xl mt-3">Deals, guides &amp; honest takes</h1>
        <p className="text-gray-400 mt-4">New article every day from people who actually play this stuff.</p>
      </div>
      <div data-testid="blog-list" className="divide-y divide-white/10 border-y border-white/10">
        {!posts ? <Skeleton className="h-40 bg-white/5 my-4" />
          : posts.length === 0 ? <p data-testid="blog-empty" className="py-16 text-center text-gray-400">First article is on its way.</p>
          : posts.map((p, i) => (
            <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-item-${p.slug}`} className="group block py-7 rise" style={{ animationDelay: `${Math.min(i, 8) * 50}ms` }}>
              <p className="text-xs text-gray-500">{fmtDate(p.created_at)} · {p.author}</p>
              <h2 className="font-display font-semibold tracking-tight text-lg sm:text-xl mt-2 group-hover:text-emerald-400 transition-colors">{p.title}</h2>
              <p className="text-sm text-gray-400 mt-2 line-clamp-2">{p.meta_description}</p>
              <span className="inline-flex items-center gap-1 text-sm text-emerald-400 mt-3">Read <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" /></span>
            </Link>
          ))}
      </div>
    </div>
  );
}
